import React, { ChangeEvent, useEffect, useState } from 'react';
import { Node } from '../model/Node';
import { DateTime } from 'luxon';
import { LicenseStateBadge } from './LicenseState';
import { ReassignLicenseModal } from './ReassignLicenseModal';

const NodeDetails = ({ node, assignedNodes, onReassignLicense, onClose }: Props) => {
  const [showReassignLicenseModal, setShowReassignLicenseModal] = useState(false);
  const [previousLicenseNode, setPreviousLicenseNode] = useState<Node | null>(null);

  useEffect(() => {
    console.log('assigned nodes', assignedNodes);
  }, [ assignedNodes ]);

  const onChangeLicense = (event: ChangeEvent<HTMLSelectElement>) => {
    const previousNode = assignedNodes.find(n => n.licenseId === event.target.value);
    if(previousNode) {
      setPreviousLicenseNode(previousNode);
      setShowReassignLicenseModal(true);
    }
  }

  const onCancelReassignLicense = () => {
    setPreviousLicenseNode(node);
    setShowReassignLicenseModal(false);
  }

  const onConfirmReassignLicense = async () => {
    if(previousLicenseNode) {
      await onReassignLicense(previousLicenseNode);
      node.licenseId = previousLicenseNode.licenseId;
      previousLicenseNode.licenseId = '';
    }
  }

  if(!node) {
    return null;
  }
  return (
    <div>
      <div className="mb-3">
        <label className="form-label">ID</label>
        <div className="border rounded p-2">{node.shortId}</div>
      </div>
      <div className="mb-3">
        <label className="form-label">Name</label>
        <div className="border rounded p-2">{node.name}</div>
      </div>
      <div className="mb-3">
        <label className="form-label">Account</label>
        <div className="border rounded p-2">{node.accountName}</div>
      </div>
      <div className="mb-3">
        <label className="form-label">Location</label>
        <div className="border rounded p-2">{node.locationName}</div>
      </div>
      <div className="mb-3">
        <label className="form-label">Installation</label>
        <div className="border rounded p-2">{node.installationName}</div>
      </div>
      <div className="mb-3">
        <label className="form-label">Installation</label>
        <div className="border rounded p-2">{node.hostName ? `${node.hostName} / ${node.ip}` : node.ip || ''}</div>
      </div>
      <div className="mb-3">
        <label className="form-label">License State</label>
        <div>
          <LicenseStateBadge state={node.licenseState} />
        </div>
      </div>
      <div className="mb-3">
        <label className="form-label">Active</label>
        <div className="border rounded p-2">{node.active ? 'TRUE' : 'FALSE'}</div>
      </div>
      <div className="mb-3">
        <label className="form-label">Added On</label>
        <div className="border rounded p-2">{node.createdDate ? DateTime.fromMillis(node.createdDate).toFormat('dd/MM/yyyy') : '-'}</div>
      </div>
      <div className="mb-3">
        <label className="form-label">Activation Date</label>
        <div className="border rounded p-2">{node.activationDate ? DateTime.fromMillis(node.activationDate).toFormat('dd/MM/yyyy') : '-'}</div>
      </div>
      <div className="mb-3">
        <label className="form-label">Renewal Date</label>
        <div className="border rounded p-2">{node.renewalDate ? DateTime.fromMillis(node.renewalDate).toFormat('dd/MM/yyyy') : '-'}</div>
      </div>
      <div className="mb-3">
        <label className="form-label">Assigned License</label>
        <select className="form-select" value={node.licenseId} onChange={onChangeLicense}>
          {
            assignedNodes.map(n => <option key={n.licenseId} value={n.licenseId}>{`${n.name} - ${n.shortId} - ${n.licenseShortId}`}</option>)
          }
        </select>
      </div>
      <button type="button" className="btn bg-danger-subtle text-danger ms-2" onClick={onClose}>Close</button>
      {previousLicenseNode && <ReassignLicenseModal show={showReassignLicenseModal} node={node} previousNode={previousLicenseNode} onConfirm={onConfirmReassignLicense} onCancel={onCancelReassignLicense} />}
    </div>
  );
}

interface Props {
  node: Node,
  assignedNodes: Node[],
  onReassignLicense: (node: Node) => Promise<void>,
  onClose: () => void
}

export { NodeDetails };